export default {"src":"/_next/static/media/product-berich.b2f6e0b1.svg","height":360,"width":360};